import * as md5 from 'md5';

export default ({ useMd5 }) => {
  const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

  if (useMd5) return md5(randomString);

  return randomString;
};
